import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTPThresholdTriggersResponse } from './types';

export function useThresholdTriggers(companyId: number | null) {
  const baseUrl = `tp-true-up/threshold-trigger?companyId=${companyId}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: TTPThresholdTriggersResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId ? baseUrl : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
